import type { VideoRelease } from './types.ts';

export const VIRTUAL_APPOINTMENTS_RELEASE: VideoRelease = {
    name: 'Virtual Appointments',
    finalLabel: 'Done',
    welcome: {
        headline: 'Virtual Appointments are here',
        subtitle: 'A seven-part video series on how VAs work at ODO'
    },
    parts: [
        {
            part: 1,
            title: 'What a VA is',
            duration: '1:23',
            youtubeId: '32hE8nfqZK4',
            icon: 'video-camera',
            tone: 'blue',
            takeaways: [
                'A remote check on a treatment, no visit needed',
                'Has a type, a team and a trigger',
                'Planned in ODO only, never in DM protocols'
            ]
        },
        {
            part: 2,
            title: 'Planning VAs',
            duration: '1:48',
            youtubeId: 'C7V-bWfYhxI',
            icon: 'calendar-days',
            tone: 'green',
            takeaways: [
                'Clinical plans VAs in the RDI and SDI wizard',
                'Pick a type, trigger, team and description',
                'An RDI can copy earlier VAs from its History tab'
            ]
        },
        {
            part: 3,
            title: 'How VAs come due',
            duration: '1:20',
            youtubeId: 'vsvyuOlTJXQ',
            icon: 'clock',
            tone: 'amber',
            takeaways: [
                'A VA opens when its trigger is reached',
                'The case moves to the DM or Clinical VA step',
                'If it has an assignee, they take the case'
            ]
        },
        {
            part: 4,
            title: 'Working VAs as DM',
            duration: '1:58',
            youtubeId: 'GGgAngu-7Ws',
            icon: 'clipboard-document-check',
            tone: 'indigo',
            takeaways: [
                'Work each open VA in Manage VAs',
                'Escalate to Clinical with a plain-words reason',
                'Click Continue treatment when nothing is open'
            ]
        },
        {
            part: 5,
            title: 'Clinical VA needed',
            duration: '1:27',
            youtubeId: 'vznswZ82YEI',
            icon: 'chat-bubble-left-right',
            tone: 'rose',
            takeaways: [
                'Cases land in Tx-3 on escalation or Clinical VAs',
                'Answer escalations, then hand back to DM',
                'Refinement and retention wait until VAs close'
            ]
        },
        {
            part: 6,
            title: 'Seeing every VA',
            duration: '1:14',
            youtubeId: 'jl-i9i3ODLU',
            icon: 'squares-2x2',
            tone: 'teal',
            takeaways: [
                'Appointments, Virtual view, across all patients',
                'Filter by team, type and practice',
                'Coloured rows flag late VAs'
            ]
        },
        {
            part: 7,
            title: 'The rules',
            duration: '1:17',
            youtubeId: '_P8_2XOYpEk',
            icon: 'shield-check',
            tone: 'purple',
            takeaways: [
                'Plan VAs in ODO, not in DM protocols',
                'Only Continue treatment ends a VA step',
                'Open VAs block refinement and retention'
            ]
        }
    ]
};
